import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GuidedTour } from '../components/ui/guided-tour';
import { tours, TOUR_ROUTES } from '../lib/tourDefinitions';

/**
 * Global tour launcher. Place once in the app layout.
 * Watches localStorage for a pending tour and launches it when on the correct page.
 */

export function TourLauncher() {
  const location = useLocation();
  const [activeTour, setActiveTour] = useState(null);

  useEffect(() => {
    // Check for pending tour after page fully loads
    const checkPending = () => {
      const pending = localStorage.getItem('pendingTour');
      if (pending && tours[pending]) {
        const expectedRoute = TOUR_ROUTES[pending];
        if (expectedRoute && location.pathname === expectedRoute) {
          localStorage.removeItem('pendingTour');
          setTimeout(() => setActiveTour(pending), 1200);
        }
      }
    };
    // Run immediately and also with a delay (for page reloads)
    checkPending();
    const timer = setTimeout(checkPending, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleComplete = () => {
    if (activeTour) {
      try {
        const completed = JSON.parse(localStorage.getItem('completedTours') || '[]');
        if (!completed.includes(activeTour)) {
          localStorage.setItem('completedTours', JSON.stringify([...completed, activeTour]));
        }
      } catch {}
    }
    setActiveTour(null);
  };

  if (!activeTour || !tours[activeTour]) return null;

  return (
    <GuidedTour
      steps={tours[activeTour].steps}
      active={true}
      onComplete={handleComplete}
      onExit={() => setActiveTour(null)}
    />
  );
}
